export default {
  title: 'SLA configuration',
  description: 'Set the SLA based on opening or scheduling date to ensure clear response times.',
  checklist: 'Checklist *',
  place: 'Place *',
  startCount: 'Start count *',
  unit: 'Count unit *',
  slaValue: 'SLA deadline *',
  warning: 'The SLA will be calculated based on the configuration in effect at the time the activity is created.'
}
